// extracted by mini-css-extract-plugin
export default {"container":"resive_container__4w-Vk","checkmark":"resive_checkmark__Nfh-o","readonly":"resive_readonly__HWbDc","icon":"resive_icon__Z7A8R"};